import { Dispatch } from 'redux';
import {
    setTimeSectionLoading,
    setTimeSlots,
} from '../actions/infiniteCalendarSeries';
import { getEventDateSessions } from '../api/dateSessions';
import { getBffRequestBaseParams } from '../selectors/bff';
import { getParentEventInfo } from '../selectors/infiniteCalendarSeries/infiniteCalendarSeries';
import { CheckoutState } from '../state';
import { DiscountType, SalesStatus } from '../state/infiniteCalendarSeries';

export type SessionResponse = {
    sessionId: string;
    startDatetime: string;
    endDatetime: string;
    checkoutEnabled: boolean;
    soldOut: boolean;
    urgencySignals?: {
        fewTickets: boolean;
        popular: boolean;
        goingFast: boolean;
    };
};

export const mapSessionsToTimeSlots = (sessions: SessionResponse[]) =>
    sessions.map((session) => ({
        // hardcoded discount for now, since backend is not returning the discount for now but time slots expect this data
        // TODO [EB-296073]: remove this once backend is returning the discount
        discount: {
            discountType: DiscountType.percentage,
            discountValue: 0,
        },
        endDatetime: session.endDatetime,
        id: session.sessionId,
        salesStatus: session.checkoutEnabled
            ? SalesStatus.onSale
            : session.soldOut
            ? SalesStatus.soldOut
            : SalesStatus.notOnSale,
        startDatetime: session.startDatetime,
        urgencySignals: session.urgencySignals || {
            fewTickets: false,
            popular: false,
            goingFast: false,
        },
    }));

export const loadSessionsForDate =
    (date: string) =>
    async (
        dispatch: Dispatch<CheckoutState>,
        getState: () => CheckoutState,
    ) => {
        dispatch(setTimeSectionLoading(true));
        dispatch(setTimeSlots([]));
        const state = getState();
        const { id: eventId } = getParentEventInfo(state);
        const { env } = getBffRequestBaseParams(state);
        try {
            const response = await getEventDateSessions({
                env,
                eventId,
                date,
            });
            dispatch(setTimeSlots(mapSessionsToTimeSlots(response)));
            dispatch(setTimeSectionLoading(false));
        } catch (error) {
            console.error('Error fetching date sessions:', error);
        }
    };
